import PropTypes from "prop-types";
import { useState, useEffect } from "react";
import { Chip } from "@mui/material";
import "./TasksListAuthorize.scss";

const TasksListAuthorize = ({ taskRecord, onNameClick, activeName }) => {
  const [displayedTotalIncome, setDisplayedTotalIncome] = useState(0); // State for animated total income

  const sortedRecords = [...taskRecord].sort((a, b) => a.income - b.income);
  const totalIncome = sortedRecords.reduce(
    (sum, record) => sum + record.income,
    0
  );

  // useEffect for animating totalIncome from current displayedTotalIncome to the new totalIncome
  useEffect(() => {
    let start = displayedTotalIncome;
    const duration = 200; // Duration in milliseconds (1 second)
    const increment = (totalIncome - start) / (duration / 10); // Calculate increment for smooth animation

    const interval = setInterval(() => {
      start += increment;
      if (
        (increment > 0 && start >= totalIncome) ||
        (increment < 0 && start <= totalIncome)
      ) {
        clearInterval(interval);
        setDisplayedTotalIncome(totalIncome); // Set the final total income value
      } else {
        setDisplayedTotalIncome(Math.floor(start)); // Update displayed value smoothly
      }
    }, 10); // Update every 10 milliseconds

    return () => clearInterval(interval); // Cleanup the interval on component unmount
  }, [totalIncome, displayedTotalIncome]);

  const handleRowClick = (name) => {
    onNameClick(name);
  };

  return (
    <div className="tasks-list-container">
      <div className="content">
        <table className="tasks-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Turn</th>
              <th>Supply</th>
              <th>Income</th>
            </tr>
          </thead>
          <tbody>
            {sortedRecords.map((record, index) => (
              <tr
                key={index}
                className={record.name === activeName ? "row-active" : ""}
                onClick={() => handleRowClick(record.name)}
              >
                <td className="name-cell">{record.name}</td>
                <td className="turn-cell">
                  <Chip
                    label={record.credits}
                    sx={{
                      fontSize: "16px",
                      fontWeight: "bold",
                      backgroundColor: "rgba(45, 191, 224, 0.36)", // Blue with opacity
                    }}
                  />
                </td>
                <td className="supply-cell">{record.supplies}</td>

                <td className="income-cell">
                  <Chip
                    label={record.income}
                    sx={{
                      fontSize: "16px",
                      fontWeight: "bold",
                      backgroundColor: "rgba(45, 191, 224, 0.36)", // Blue with opacity
                    }}
                  />
                </td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan="3" className="total-label">
                Total:
              </td>
              <td className="total-income">{displayedTotalIncome}</td>
              <td></td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
};

TasksListAuthorize.propTypes = {
  taskRecord: PropTypes.array.isRequired,
  onNameClick: PropTypes.func.isRequired,
  activeName: PropTypes.string,
};

export default TasksListAuthorize;
